import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { map } from 'rxjs/operators';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import { ELearningManagementService } from './e-learning-management.service';

@Component({
  selector: 'app-e-learning-management',
  templateUrl: './e-learning-management.component.html',
  styleUrls: ['./e-learning-management.component.scss']
})
export class ELearningManagementComponent implements OnInit {
  allCourse: any;
  page = 1;
  pageSize = 10;
  collectionSize: number;
  rows: any[];
  search: string;
  isSearch: boolean = false;
  searchCourse: any = '';
  locationUrl: string = window.location.origin;
  alwaysOpen = true;

  column = [{
    field: 'COURSE_NUMBER',
    courseId: 'COURSE_ID',
    header: 'รหัสคอร์ส',
    class: 'col'
  }, {
    field: 'COURSE_NAME',
    courseName: 'COURSE_NAME',
    header: 'ชื่อคอร์สเรียน',
    class: 'col'
  }, {
    field: 'COURSE_START',
    field2: 'COURSE_END',
    header: 'วันเวลา เปิด-ปิด',
    class: 'col-3'
  },
  //  {
  //   field: 'COURSE_CREATE',
  //   header: 'วันที่สร้าง',
  //   class: 'col-3'
  // },
  {
    field: 'COURSE_STATUS',
    header: 'สถานะ',
    class: 'col-1'
  }, {
    field: 'USERNAME',
    header: 'ผู้มีสิทธิ์ จัดการคอร์ส',
    class: 'col'
  }, {
    field: 'COURSE_PRICE',
    field2: 'COURSE_SPECIALPRICE',
    header: 'ราคาปกติ / ราคาพิเศษ',
    class: 'col-1'
  }, {
    field: 'COURSE_REVIEW',
    header: 'รีวิว',
    class: 'col-1'
  }, {
    field: 'COURSE_CHAT',
    header: 'แชท',
    class: 'col-1'
  }, {
    field: 'COURSE_ASSIGNMENT',
    header: 'Assignment',
    class: 'col-1'
  }, {
    field: 'EDIT',
    header: 'แก้ไข',
    class: 'col-1'
  }, {
    field: 'MESSAGE_ALERT',
    header: 'ข้อความ',
    class: 'col-1'
  }]

  constructor(
    public matDialog: MatDialog,
    private elearningManagement: ELearningManagementService,
    private gobalFunctionService: GobalFunctionService
  ) { }

  ngOnInit(): void {
    this.getAllCoure();
    this.gobalFunctionService.setTitle('การจัดการคอร์สเรียน');
  }

  addCourse() {
    window.open('/e-learning-management/manage-course?isEdit=false', '_blank');
  }

  getAllCoure() {
    this.elearningManagement.getAllCourse().pipe(
      map(courses => {
        this.allCourse = courses.result.reverse();
        // console.log(this.allCourse);

        this.refresh();
      })
    ).subscribe()
  }

  edit(cid) {
    window.open('/e-learning-management/manage-course?isEdit=true&course_id=' + cid, '_blank');
  }

  assign(cid) {
    window.open('/e-learning-management/assignment?isAssign=true&course_id=' + cid, '_blank');
  }

  review(cid) {
    window.open('/e-learning-management/review-management?course_id=' + cid, '_blank');
  }

  chat(cid) {
    window.open('/e-learning-management/chat-management?course_id=' + cid, '_blank');
  }

  privateChat(cid){
    window.open('/e-learning-management/private-chat-management?course_id=' + cid, '_blank');
  }

  searching() {
    if (this.search !== '') {
      this.isSearch = true;
      this.searchCourse = [];
      this.allCourse.filter(course => {
        if (course.COURSE_NAME.toLowerCase().includes(this.search.toLowerCase())) {
          this.searchCourse.push(course)
        }
      });
      this.refreshSearch();
    } else {
      this.isSearch = false
      this.searchCourse = null;
      this.getAllCoure();
    }
    // console.log(this.searchCourse);
  }

  refresh() {
    this.collectionSize = this.allCourse.length;
    this.rows = this.allCourse
      .map((account, i) => ({ id: i + 1, ...account }))
      .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
  }

  refreshSearch() {
    this.collectionSize = this.searchCourse.length;
    this.rows = this.searchCourse
      .map((account, i) => ({ id: i + 1, ...account }))
      .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
  }
}
